import { Capacitor } from '@capacitor/core'

import { CardContainer } from '@apps-common/components/common'
import { SectionTitle } from '@apps-common/components/common/portal-title'
import { ToggleInputSM } from '@apps-common/components/elements/form'
import { VertSpacerMd } from '@apps-common/components/layout'
import { useNotifications } from '@apps-common/contexts'

export const PushSettings = () => {
  const notifications = useNotifications()
  const { settingsLoading, settings, updateSettings } = notifications || {}

  const disabled = false
  const loading = settingsLoading === undefined ? true : settingsLoading
  const isNative = Capacitor.isNativePlatform()

  return (
    <div className='max-w-[1000px]'>
      <CardContainer bgClasses='bg-surface border border-border md:px-5 md:py-4'>
        <div className='flex items-center justify-between'>
          <SectionTitle classes='text-text-muted/70 text-left pl-[10px]' text='Notifications' />
        </div>
        <VertSpacerMd />
        <div className='flex flex-col gap-2 text-text rounded-[30px] py-3 pr-3 sm:py-3 sm:pr-4'>
          {isNative && (
            <ToggleInputSM
              labelLeft='App notifications'
              containerClassName='!mb-0'
              innerContainerClassName='!m-0 !px-0'
              disabled={disabled}
              registration={{
                checked: settings?.receiveAppNotifications || false,
                onChange: (e: any) => {
                  if (updateSettings && !loading) {
                    updateSettings({ model: { ...settings, receiveAppNotifications: e?.target?.checked || false } })
                  }
                }
              }}
            />
          )}
          {!isNative && (
            <ToggleInputSM
              labelLeft='Web notifications'
              containerClassName='!mb-0'
              innerContainerClassName='!m-0 !px-0'
              disabled={disabled}
              registration={{
                checked: settings?.receiveWebNotifications || false,
                onChange: (e: any) => {
                  if (updateSettings && !loading) {
                    updateSettings({ model: { ...settings, receiveWebNotifications: e?.target?.checked || false } })
                  }
                }
              }}
            />
          )}
          <ToggleInputSM
            labelLeft='New device activations'
            containerClassName='!mb-0'
            innerContainerClassName='!m-0 !px-0'
            disabled={disabled}
            registration={{
              checked: settings?.recieveUnitActivationNotifications || false,
              onChange: (e: any) => {
                if (updateSettings && !loading) {
                  updateSettings({ model: { ...settings, recieveUnitActivationNotifications: e?.target?.checked || false } })
                }
              }
            }}
          />
          <ToggleInputSM
            labelLeft='Monitoring changes'
            containerClassName='!mb-0'
            innerContainerClassName='!m-0 !px-0'
            disabled={disabled}
            registration={{
              checked: settings?.recieveMonitoringChangeNotifications || false,
              onChange: (e: any) => {
                if (updateSettings && !loading) {
                  updateSettings({ model: { ...settings, recieveMonitoringChangeNotifications: e?.target?.checked || false } })
                }
              }
            }}
          />
          <ToggleInputSM
            labelLeft='Server/receiver'
            containerClassName='!mb-0'
            innerContainerClassName='!m-0 !px-0'
            disabled={disabled}
            registration={{
              checked: settings?.recieveRadionetServerNotifications || false,
              onChange: (e: any) => {
                if (updateSettings && !loading) {
                  updateSettings({ model: { ...settings, recieveRadionetServerNotifications: e?.target?.checked || false } })
                }
              }
            }}
          />
        </div>
      </CardContainer>
    </div>
  )
}
